import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from '../../contexts/ThemeContext';

interface ActivityChartProps {
  data: number[];
  title?: string;
}

const ActivityChart: React.FC<ActivityChartProps> = ({
  data,
  title = 'Atividade (Ultimas 24h)',
}) => {
  const { isDark } = useTheme();

  // Generate hour labels and format data
  const chartData = data.map((value, index) => ({
    hour: `${index}:00`,
    mensagens: value,
  }));

  return (
    <div className={`rounded-lg shadow-sm ${isDark ? 'bg-gray-800' : 'bg-white'} p-6`}>
      <h3 className={`text-lg font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>
        {title}
      </h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid
              strokeDasharray="3 3"
              stroke={isDark ? '#374151' : '#e5e7eb'}
            />
            <XAxis
              dataKey="hour"
              stroke={isDark ? '#9ca3af' : '#6b7280'}
              fontSize={12}
              tickLine={false}
              interval={3}
            />
            <YAxis
              stroke={isDark ? '#9ca3af' : '#6b7280'}
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: isDark ? '#1f2937' : '#ffffff',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
              }}
              labelStyle={{
                color: isDark ? '#f3f4f6' : '#111827',
                fontWeight: 600,
              }}
              itemStyle={{
                color: '#22c55e',
              }}
            />
            <Line
              type="monotone"
              dataKey="mensagens"
              stroke="#22c55e"
              strokeWidth={2}
              dot={false}
              activeDot={{
                r: 6,
                fill: '#22c55e',
                stroke: isDark ? '#1f2937' : '#ffffff',
                strokeWidth: 2,
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ActivityChart;
